<!--Login Wrapper-->
<div class="login-wrapper pt-xl-5">
  <div class="login-content text-center">
    <div class="login-inner-wrapper-2 shadow-box p-4">
      <div class="sidebar-logo d-flex justify-content-center mb-4">
        <div class="logo-sign">
          <img src="assets/img/epion-logo.png" alt="Epion Login" height="50" />
        </div>
      </div>
      <div class="mb-4">
        <p class="text-dark font-weight-bold mb-0 letter-space-1">
          {{'Welcome To Epion'|translate}}
        </p>
        <h2 class="text-primary font-weight-normal">
          {{'Sign into your account'|translate}}
        </h2>
      </div>
    
       
          <div class="input-group mb-3">
            <input name="username" Name="UserName"  type="text" placeholder="User Name" autocomplete="username" />
          </div>
          <div class="input-group mb-3">
            <input name="password" autocomplete="current-password" />
          </div>
          <div class="mb-3">
            <button type="button" class="btn btn-primary btn-sm m-1 hover-transform" (click)="routetocomp();"  >Login
          <i class="fa fa-user ml-1"></i>
        </button>
          </div>
       
     
    </div>
    <!-- login form wrapper closed -->
  </div>
  <!-- login-one- wrapper closed -->
</div>